import { lazy } from 'react';

const Bp = lazy(() => import('./pages/Case Studies/Subpages/Bp'));
const Canvas = lazy(() => import('./pages/Canvas/Canvas'));
const Inttix = lazy(() => import('./pages/Case Studies/Subpages/Inttix'));
const Kobo = lazy(() => import('./pages/Case Studies/Subpages/Kobo'));
const Liveli = lazy(() => import('./pages/Case Studies/Subpages/Liveli'));
const Geria = lazy(() => import('./pages/Case Studies/Subpages/Geria'));
const Jaguar = lazy(() => import('./pages/Case Studies/Subpages/Jaguar'));
const Microsoft = lazy(() => import('./pages/Microsoft/Microsoft'));
const CaseList = lazy(() => import('./pages/Case Studies/CaseList'));
const Cyber = lazy(() => import('./pages/cybersecurity/Cyber'));
const IcanTutors = lazy(
    () => import('./pages/Case Studies/Subpages/IcanTutors')
);
const IlearnCloud = lazy(
    () => import('./pages/Case Studies/Subpages/Ilearncloud')
);

const Consultation = lazy(
    () => import('./pages/ScheduleConsultation/Consultation')
);
const AWSManagedCloud = lazy(() => import('./pages/Solutions/AWSManagedCloud'));
const AWSMaturityService = lazy(
    () => import('./pages/Maturity Service/MaturityService')
);

// case studies
const Mkobo = lazy(() => import('./pages/Case Studies/Subpages/Mkobo'));
const BillyRonks = lazy(
    () => import('./pages/Case Studies/Subpages/BillyRonks')
);

const GtbPensions = lazy(
    () => import('./pages/Case Studies/Subpages/gtb/GtbPensions')
);
const PhastPay = lazy(() => import('./pages/Case Studies/Subpages/Phastpay'));
const Alarrt = lazy(() => import('./pages/Case Studies/Subpages/Alarrt'));

// blog pages
const BlogList = lazy(() => import('./pages/Blog/BlogList'));
const Blog_One = lazy(() => import('./pages/Blog/pages/blog_one'));
const Blog_two = lazy(() => import('./pages/Blog/pages/blog_two'));
const Blog_five = lazy(() => import('./pages/Blog/pages/blog_five'));
const Blog_six = lazy(() => import('./pages/Blog/pages/blog_six'));
const Blog_seven = lazy(() => import('./pages/Blog/pages/blog_seven'));
const Blog_eight = lazy(() => import('./pages/Blog/pages/blog_eight'));
const Blog_nine = lazy(() => import('./pages/Blog/pages/blog_nine'));
const Blog_three = lazy(() => import('./pages/Blog/pages/blog_three'));
const Blog_ten = lazy(() => import('./pages/Blog/pages/blog_ten'));
const Blog_eleven = lazy(() => import('./pages/Blog/pages/blog_eleven'));
const Blog_twelve = lazy(() => import('./pages/Blog/pages/blog_twelve'));
const Blog_thirteen = lazy(() => import('./pages/Blog/pages/blog_thirteen'));
const BlogFortySix = lazy(() => import('./pages/Blog/pages/blog_fortySix'));
const BlogFourteen = lazy(() => import('./pages/Blog/pages/blog_fourteen'));
const BlogFifteen = lazy(() => import('./pages/Blog/pages/blog_fifteen'));
const BlogSixteen = lazy(() => import('./pages/Blog/pages/blog_sixteen'));
const BlogSeventeen = lazy(() => import('./pages/Blog/pages/blog_seventeen'));
const BlogEighteen = lazy(() => import('./pages/Blog/pages/blog_eighteen'));
const BlogNineteen = lazy(() => import('./pages/Blog/pages/blog_nineteen'));
const BlogTwenty = lazy(() => import('./pages/Blog/pages/blog_twenty'));
const BlogTwentyOne = lazy(() => import('./pages/Blog/pages/blog_twentyone'));
const BlogTwentyTwo = lazy(() => import('./pages/Blog/pages/blog_twentytwo'));
const BlogTwentyThree = lazy(
    () => import('./pages/Blog/pages/blog_twentythree')
);
const BlogTwentyFour = lazy(() => import('./pages/Blog/pages/blog_twentyfour'));
const BlogTwentyFive = lazy(() => import('./pages/Blog/pages/blog_twentyfive'));
const BlogTwentySix = lazy(() => import('./pages/Blog/pages/blog_twentysix'));
const BlogTwentySeven = lazy(
    () => import('./pages/Blog/pages/blog_twentyseven')
);
const BlogTwentyEight = lazy(
    () => import('./pages/Blog/pages/blog_twentyeight')
);
const BlogTwentyNine = lazy(() => import('./pages/Blog/pages/blog_twentynine'));
const BlogThirty = lazy(() => import('./pages/Blog/pages/blog_thirty'));
const BlogThirtyOne = lazy(() => import('./pages/Blog/pages/blog_thirtyone'));
const BlogThirtyTwo = lazy(() => import('./pages/Blog/pages/blog_thirtytwo'));
const BlogThirtyThree = lazy(
    () => import('./pages/Blog/pages/blog_thirtyThree')
);
const BlogThirtyFour = lazy(() => import('./pages/Blog/pages/blog_thirtyfour'));
const BlogThirtyFive = lazy(() => import('./pages/Blog/pages/blog_thirtyFive'));
const BlogThirtySix = lazy(() => import('./pages/Blog/pages/blog_thirtySix'));
const BlogThirtySeven = lazy(
    () => import('./pages/Blog/pages/blog_thirtySeven')
);
const BlogThirtyEight = lazy(
    () => import('./pages/Blog/pages/blog_thirtyEight')
);
const BlogThirtyNine = lazy(() => import('./pages/Blog/pages/blog_thirtyNine'));
const BlogForty = lazy(() => import('./pages/Blog/pages/blog_forty'));
const BlogFortyOne = lazy(() => import('./pages/Blog/pages/blog_fortyOne'));
const BlogFortyTwo = lazy(() => import('./pages/Blog/pages/blog_fourtyTwo'));
const BlogFortyThree = lazy(() => import('./pages/Blog/pages/blog_fortyThree'));
const BlogFortyFour = lazy(() => import('./pages/Blog/pages/blog_fortyFour'));
const BlogFortyFive = lazy(() => import('./pages/Blog/pages/blog_fortyFive'));
const BlogFortySeven = lazy(() => import('./pages/Blog/pages/blog_fortySeven'));
const BlogFortyEight = lazy(() => import('./pages/Blog/pages/blog_fortyEight'));
const BlogFortyNine = lazy(() => import('./pages/Blog/pages/blog_fortyNine'));

// partnership pages
const Ec2 = lazy(() => import('./pages/aws_partnership/AWSEC2/Ec2'));
const RDSReady = lazy(() => import('./pages/aws_partnership/RDSReady'));
const AWSLambda = lazy(() => import('./pages/aws_partnership/AWSLambda'));
const CloudMigration = lazy(
    () => import('./pages/aws_partnership/Cloud Migration/MainPage')
);
const Transfer = lazy(
    () => import('./pages/aws_partnership/AWSTransfer/Transfer')
);
const CloudFront = lazy(
    () => import('./pages/aws_partnership/AWSCloudFront/CloudFront')
);
const DataAnalytics = lazy(
    () => import('./pages/aws_partnership/DataAnalytics/DataAnalytics')
);
const AWSDynamoDb = lazy(
    () => import('./pages/aws_partnership/AWSDynamo/AWSDynamo')
);
const CloudResouce = lazy(
    () => import('./pages/aws_partnership/CloudResouce/CloudResouce')
);
const SecurityCompliance = lazy(
    () =>
        import('./pages/aws_partnership/securityCompliance/SecurityCompliance')
);
const AWSWellArchitected = lazy(
    () => import('./pages/aws_partnership/Well Architected/AWSWellArchitected')
);

// Course Ads
const AWSAds = lazy(() => import('./pages/Course Ads/AWSCertifiedAds'));
const PowerBiAds = lazy(() => import('./pages/Course Ads/PowerBiAds'));
const MicrosoftAzureAds = lazy(
    () => import('./pages/Course Ads/MicrosoftAzureAds')
);
const Contact = lazy(() => import('./pages/Contact'));
const ScheduleDemo = lazy(() => import('./pages/ScheduleDemo'));
const ProfessionalServies = lazy(
    () => import('./pages/Professional Service/ProfessionalServices')
);
const Pricing = lazy(() => import('./pages/Pricing'));
const AWSPartnership = lazy(
    () => import('./pages/AWSPartnership/AWSPartnership')
);
const Knowledge = lazy(() => import('./pages/Knowledge'));
const PagePrivacy = lazy(() => import('./pages/Utility/PagePrivacy'));
const PageTerms = lazy(() => import('./pages/Utility/PageTerms'));
const CookiePolicyMore = lazy(() => import('./pages/Utility/CookiePolicyMore'));

const LandingPage = lazy(() => import('./pages/Landing Page/LandingPage'));
const Startups = lazy(() => import('./pages/startup/Startups'));
const Glow = lazy(() => import('./pages/Glow'));
const Training = lazy(() => import('./pages/Training/Training'));
const FoundersLab = lazy(() => import('./pages/Founders Lab/FoundersLab'));
const TrainingContact = lazy(() => import('./pages/Training/Contact'));

// Events Pages
const EventsPage = lazy(() => import('./pages/Events/Events'));
const Events_One = lazy(() => import('./pages/Events/Events1'));
const Events_Two = lazy(() => import('./pages/Events/Events2'));
const Events_Three = lazy(() => import('./pages/Events/Events3'));
const Events_Four = lazy(() => import('./pages/Events/Events4'));
const Events_Five = lazy(() => import('./pages/Events/Events5'));
const Fintech = lazy(() => import('./pages/Events/Fintech Fusion/Fintech'));

// White Paper Pages
const WhitePaper = lazy(() => import('./pages/White Paper/WhitePaper'));
const WhitePaperOne = lazy(() => import('./pages/White Paper/WhitePaperOne'));
const WhitePaperTwo = lazy(() => import('./pages/White Paper/WhitepaperTwo'));
const Backup = lazy(() => import('./pages/Backup & Restore/Main'));
const Innovation = lazy(() => import('./pages/Innovation/Innovation'));
const Technologies = lazy(() => import('./pages/Technologies/Technologies'));
const DevopsPage = lazy(() => import('./pages/Solutions/DevOps'));
const PressRelease = lazy(() => import('./pages/PressRelease/PressRelease'));
const Description = lazy(() => import('./pages/coursedescription/Description'));

const componentRoutes = [
    { path: '/', element: LandingPage },
    { path: '/training', element: Training },
    { path: '/startups', element: Startups },
    { path: '/cybersecurity', element: Cyber },
    { path: '/events', element: EventsPage },
    { path: '/founders-lab', element: FoundersLab },
    { path: '/edge-computing', element: Events_One },
    { path: '/contact-training', element: TrainingContact },
    { path: '/innovation-challenge', element: Innovation },
    {
        path: '/leveraging-cloud-solutions-for-business-growth',
        element: Events_Two,
    },
    {
        path: '/getting-your-security-foundations-right',
        element: Events_Three,
    },
    { path: '/cloud-security-and-requirements', element: Events_Four },
    { path: '/cloud-modernization', element: Events_Five },
    { path: '/backup-and-restore', element: Backup },
    { path: '/course-description', element: Description },
    { path: '/whitepaper', element: WhitePaper },
    {
        path: '/is-migrating-to-the-cloud-chasing-the-clouds',
        element: WhitePaperOne,
    },
    { path: '/how-secure-is-your-data', element: WhitePaperTwo },
    { path: '/cloud-migration', element: CloudMigration },
    { path: '/glow', element: Glow },
    { path: '/pricing', element: Pricing },
    { path: '/aws-partnership', element: AWSPartnership },
    { path: '/aws-dynamo-db', element: AWSDynamoDb },
    { path: '/security-compliance', element: SecurityCompliance },
    { path: '/microsoft-on-aws', element: Microsoft },
    { path: '/cloud-resource-managament', element: CloudResouce },
    { path: '/amazon-cloudfront-delivery', element: CloudFront },
    { path: '/amazon-ec2', element: Ec2 },
    { path: '/aws-transfer-family', element: Transfer },
    {
        path: '/aws-well-architected-framework-alignment',
        element: AWSWellArchitected,
    },
    { path: '/knowledge', element: Knowledge },
    { path: '/contact-us', element: Contact },
    { path: '/schedule-demo', element: ScheduleDemo },
    { path: '/page-privacy', element: PagePrivacy },
    { path: '/page-terms', element: PageTerms },
    { path: '/cookie-policy-more', element: CookiePolicyMore },
    { path: '/professional-services', element: ProfessionalServies },
    { path: '/technologies', element: Technologies },
    { path: '/power-bi-contact-form', element: PowerBiAds },
    { path: '/aws-contact-form', element: AWSAds },
    { path: '/microsoft-azure-contactform', element: MicrosoftAzureAds },
    { path: '/data-analytics', element: DataAnalytics },
    { path: '/download-canvas', element: Canvas },
    { path: '/schedule-consultation', element: Consultation },
    { path: '/devops-as-a-service', element: DevopsPage },
    { path: '/press-release', element: PressRelease },
    { path: '/aws-managed-cloud', element: AWSManagedCloud },
    { path: '/fintech-fusion-summit', element: Fintech },
    { path: '/blog', element: BlogList },
    {
        path: '/cloudplexo-achieves-aws-isv-partner-status-in-aws-partner-network',
        element: Blog_One,
    },
    {
        path: '/can-smes-benefit-from-cloud-cost-management-tools',
        element: Blog_three,
    },
    {
        path: '/ways-companies-can-save-on-their-cloud-computing-costs',
        element: Blog_two,
    },
    {
        path: '/the-benefits-of-building-a-cloud-native-company',
        element: Blog_five,
    },
    { path: '/aws-well-architected-framework-alignment', element: Blog_six },
    {
        path: '/aws-cost-optimization-while-achieving-your-desired-business',
        element: Blog_eight,
    },
    {
        path: '/rightsizing-recommendation-an-approach-to-save-on-your-aws-cost',
        element: Blog_nine,
    },
    { path: '/aws-service-limits-monitoring', element: Blog_seven },
    {
        path: '/how-does-the-cloud-enable-agile-digital-transformations',
        element: Blog_ten,
    },
    { path: '/will-cloud-computing-rule-the-world', element: Blog_eleven },
    { path: '/why-build-on-the-cloud', element: Blog_twelve },
    {
        path: '/what-cloud-optimisation-is-and-why-it-matters',
        element: Blog_thirteen,
    },
    {
        path: '/introduction-to-writing-serverless-application',
        element: BlogFourteen,
    },
    { path: '/video-detection-with-aws-rekognition', element: BlogSeventeen },
    {
        path: '/aws-lambda-introduction-to-writing-serverless-applications',
        element: BlogFifteen,
    },
    {
        path: '/aws-sam-build-test-and-deploy-serveless-applications',
        element: BlogSixteen,
    },
    { path: '/10-aws-services', element: BlogEighteen },
    {
        path: '/continuous-deployment-using-github-actions',
        element: BlogNineteen,
    },
    { path: '/unravelling-cloud-billing-solutions', element: BlogTwenty },
    {
        path: '/cloudplexo-ascends-to-advanced-tier-consulting-&-technology-partner-with-aws',
        element: BlogTwentyOne,
    },
    { path: '/hands-on-with-aws-comprehend', element: BlogTwentyTwo },
    { path: '/hands-on-with-aws-transcribe', element: BlogTwentyThree },
    { path: '/hands-on-aws-polly', element: BlogTwentyFour },
    {
        path: "a-beginner's-guide-to-aws-fargate-and-ec2",
        element: BlogTwentyFive,
    },
    {
        path: '/amazon-api-gateway-service-delivery-enhancing-efficiency-and-connectivity',
        element: BlogTwentySix,
    },
    {
        path: '/cloudplexo-receives-aws-lambda-service-delivery-designation',
        element: BlogTwentySeven,
    },
    {
        path: '/advanced-document-processing-with-aws-textract',
        element: BlogTwentyEight,
    },
    {
        path: '/strategies-to-achieving-business-agility-with-cloud-native-culture',
        element: BlogTwentyNine,
    },
    {
        path: '/best-practices-building-scalable-apps-with-serverless-architecture',
        element: BlogThirty,
    },
    {
        path: '/best-practices-to-ensuring-data-resilience-with-cloud-native-backup',
        element: BlogThirtyOne,
    },
    {
        path: '/unlocking-efficiency-and-innovation-with-cloudplexo',
        element: BlogThirtyTwo,
    },
    {
        path: '/designing-well-architected-aws-solutions',
        element: BlogThirtyThree,
    },
    {
        path: '/effective-monitoring-of-aws-service-limits',
        element: BlogThirtyFour,
    },
    {
        path: '/maximizing-cloud-benefits-for-businesses',
        element: BlogThirtyFive,
    },
    {
        path: '/optimizing-cloud-costs-for-businesses-with-cloudplexo',
        element: BlogThirtySix,
    },
    {
        path: '/strategies-to-optimizing-aws-costs-for-business-efficiency',
        element: BlogThirtySeven,
    },
    {
        path: '/unlocking-the-power-of-aws-managed-cloud',
        element: BlogThirtyEight,
    },
    {
        path: '/aws-comprehend-and-its-role-in-nlp',
        element: BlogThirtyNine,
    },
    {
        path: '/introduction-to-aws-cli-basic-commands-for-beginners',
        element: BlogForty,
    },
    {
        path: '/building-a-basic-web-application-on-aws',
        element: BlogFortyOne,
    },
    {
        path: '/uploading-and-downloading-files-from-amazon-sw3-using-boto3',
        element: BlogFortyTwo,
    },
    {
        path: '/understanding-the-difference-between-aws-sns-and-sqs',
        element: BlogFortyThree,
    },
    {
        path: '/uploading-large-files-upto-5tb-to-amazon-s3-using-boto3-in-python',
        element: BlogFortyFour,
    },
    {
        path: '/how-to-deploy-and-host-your-web-app-on-aws-amplify',
        element: BlogFortyFive,
    },
    {
        path: '/aws-step-functions-a-practical-guide',
        element: BlogFortySix,
    },
    {
        path: '/getting-started-with-dynamodb-a-practical-approach',
        element: BlogFortySeven,
    },
    {
        path: '/serverless-compute-comparison-aws-lambda-vs-azure-functions-vs-google-cloud-functions',
        element: BlogFortyEight,
    },
    {
        path: '/building-fullstack-app-with-react-and-aws-amplify-authentication-and-databases',
        element: BlogFortyNine,
    },
    { path: '/case-studies', element: CaseList },
    { path: '/case-study-of-gt-pensions-managers', element: GtbPensions },
    {
        path: '/billyronks-selected-cloudplexo-as-aws-advanced-partner',
        element: BillyRonks,
    },
    { path: '/mkobo-uses-cloudplexo-saas-solution', element: Mkobo },
    {
        path: '/phastpay-collaborated-with-cloudplexo-experts-and-leveraging-on-cloudplexo-saas-solution',
        element: PhastPay,
    },
    {
        path: '/alarrt-achieves-enhanced-cost-efficiency-elevated-security-standards-and-a-highly-scalable-and-efficient-infrastructure',
        element: Alarrt,
    },
    { path: '/case-study-in-the-edtech-sector', element: IcanTutors },
    { path: '/liveli-case-study', element: Liveli },
    { path: '/geria-case-study', element: Geria },
    { path: '/ilearncloud-case-study', element: IlearnCloud },
    { path: '/inttix-case-study', element: Inttix },
    { path: '/kobo-case-study', element: Kobo },
    { path: '/jaguar-and-land-rover-case-study', element: Jaguar },
    { path: '/bp-case-study', element: Bp },
    { path: '/rds-ready', element: RDSReady },
    { path: '/aws-lambda-service', element: AWSLambda },
    { path: '/aws-maturity-service', element: AWSMaturityService },
];

export { componentRoutes };
